import { Colors } from '@chakra-ui/react';
import { COLORS } from '~/constants/colors';

const colors: Colors = COLORS;

export default colors;
